import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import moment from "moment";

import { PageHeaderItem } from "components/BudgetBuilder/PageHeader/PageHeaderItem";
import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import { awardSelectors, proposalSelectors, budgetBuilderSelectors } from "store/selectors";
import useBudgetBuilder from "hooks/useBudgetBuilder";

import styles from "./styles.css";


const PageHeader = () => {
	const budgetType =  useSelector(budgetBuilderSelectors.budgetType);
	const { proposalNumber } = useSelector(proposalSelectors.proposal);
	const { awardNumber } = useSelector(awardSelectors.award);
	const formContent = useSelector(budgetBuilderSelectors.budgetBuilderFormContent);
	const periodList = useSelector(budgetBuilderSelectors.periodRows);

	const { dateFormatter } = useTenantFormatter();
	const budgetBuilderContent = useBudgetBuilder();

	const startEndDateText = useMemo(() => {
		let startDate = null;
		let endDate = null;
		for (let period of periodList) {
			if (!startDate || moment(period.startDate).isBefore(moment(startDate))) {
				startDate = period.startDate;
			}
			if (!endDate || moment(period.endDate).isAfter(moment(endDate))) {
				endDate = period.endDate;
			}
		}

		if (startDate && endDate) {
			return `${dateFormatter(startDate)} - ${dateFormatter(endDate)}`;
		}

		return null;
	}, [ dateFormatter, periodList ]);

	return (
		<div className={styles.headerContainer}>
			<div className={styles.headerWrapper}>
				{budgetType === "proposal" && (
					<PageHeaderItem text={"Proposal Number"}>
						{proposalNumber || ""}
					</PageHeaderItem>
				)}
				{budgetType === "award" && (
					<PageHeaderItem text={"Award Number"}>
						{awardNumber || ""}
					</PageHeaderItem>
				)}
				<PageHeaderItem text={"Project Start/End Dates"}>
					{startEndDateText}
				</PageHeaderItem>
				<PageHeaderItem text={"Periods"}>
					{formContent?.budgetPeriods?.numberOfPeriods || ""}
				</PageHeaderItem>
			</div>
			<div className={styles.headerCostWrapper}>
				<PageHeaderItem text={"Direct Cost"}>
					{budgetBuilderContent.totalDirectCosts}
				</PageHeaderItem>
				<PageHeaderItem text={"F&A Cost"}>
					{budgetBuilderContent.faCostSubtotal}
				</PageHeaderItem>
				<PageHeaderItem text={"Proposed Cost"}>
					{budgetBuilderContent.proposedCostSubtotal}
				</PageHeaderItem>
				<PageHeaderItem text={"Cost Share"}>
					{budgetBuilderContent.costShareSubtotal}
				</PageHeaderItem>
				<PageHeaderItem text={"Total Project Cost"}>
					{budgetBuilderContent.total}
				</PageHeaderItem>
			</div>
		</div>
	);
};


export default PageHeader;
